import { render, staticRenderFns } from "./CalendarPublicHolidays.vue?vue&type=template&id=63577c5e&"
import script from "./CalendarPublicHolidays.vue?vue&type=script&lang=js&"
export * from "./CalendarPublicHolidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports